<div class="flex flex-col full-grow-no-shrink-no-basis w-p-100">
  <particle-task-header [data]="data" [taskMenuItemsMapper]="taskMenuItemsMapper"
                        (actionEvent$)="onActionEvent($event)"></particle-task-header>
  <div class="flex flex-col simple-scroll p-r-8 full-grow-no-shrink-no-basis">
    <particle-task-description [data]="data"></particle-task-description>
    <particle-task-checklist *ngIf="taskMenuItemsMapper.hasOwnProperty('TaskChecklist')" [dynamicData]="data.input"
                             [data]="data"></particle-task-checklist>
    <particle-task-attachments *ngIf="taskMenuItemsMapper.hasOwnProperty('TaskAttachment')" [dynamicData]="data.input"
                               [data]="data"
                               [openAddAttachmentDialog$]="openAddAttachmentDialog$"></particle-task-attachments>
    <particle-task-comment [dynamicData]="data.input"
                           [focusAddCommentBox$]="focusAddCommentBox$"></particle-task-comment>
  </div>
</div>
